<template>
    <div>
        <v-container fluid>
            <h1 class="mb-3">
                LLM Configuration
                <b>({{ bot.botTitle }})</b>
                <v-chip v-clipboard:copy="bot.botId" class="cursor-pointer ml-4" v-clipboard:success="onCopy">
                    {{ bot.botId }} <v-icon small class="pl-2">file_copy</v-icon>
                </v-chip>
            </h1>
            <div class="card-curvey ">
                <LLMForm v-if="config.account || showForm" ref="addApp" :currentBots="list" :data="currentBot"
                    :action="config.account ? 'edit' : 'add'" @loading="addButtonLoader = $event" @success="editDone">
                </LLMForm>
                <div v-else class="card-flex-center">
                    <p>
                        No LLM Configuration added yet
                    </p>
                    <v-btn @click="showForm = true" color="primary" dark>
                        Add Configuration
                    </v-btn>
                </div>
                <!-- <pre>
                {{ currentBot }}
                </pre> -->
            </div>
        </v-container>
    </div>
</template>
<script>
import LLMForm from "./apps/LLMForm";
export default {
    name: "configuration",
    components: {
        LLMForm,
    },
    data() {
        return {
            accountID: "",
            addButtonLoader: false,
            showForm: false,
        };
    },
    async mounted() {
        this.accountID = this.$store.state.user.userData.corporate_id;
        await this.getApps();
        // console.log(this.getBot("NNIrYNvRAvZIjeRQdAGS"), 'bot')
    },
    computed: {
        bot() {
            return this.$store.state.bot;
        },
        list() {
            return this.$store.getters['llm/get'];
        },
        currentBot() {
            return this.list.find(bot => bot.botID === this.bot.botId) || { botID: this.bot.botId };
        },
        config() {
            const bot = this.currentBot;
            if (bot && bot.activeModel) {
                return bot[bot.activeModel]
            }
            return false
        }
    },
    methods: {
        getApps() {
            this.$store.dispatch('llm/get', this.accountID)
                .catch(err => {
                    this.$store.dispatch('setErrorMessage', err)
                })

            this.$store.dispatch('llm/consumption', this.accountID).catch(err => {
                this.$store.dispatch('setErrorMessage', err)
            })
        },
        onCopy() {
            this.$store.dispatch("setSnackbar", {
                text: "Text copied to your clipboard",
                color: "primary",
                status: true,
            });
        },
        editDone() {
            this.$store.dispatch("setSnackbar", {
                text: `LLm ${this.config.account ? 'updated' : 'added'} successfully`,
                color: "success",
                status: true,
            });
            this.getApps();
        }
    },
};
</script>

<style scoped>
.card-flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 40px;
}
</style>